const initialData = {
  books: [],
  loading: false,
  error: null,
};

export default initialData;
